import React, { useState, useRef, useEffect, useMemo } from "react";
import "../../css/MFManagement/MFManagement.css";
import { NavLink, useLocation } from "react-router-dom";
import MFRoutes from "./MFRoutes";
import {
  BookMark,
  Portfolio,
  ProfileUser,
  SIP,
  SIPTransaction,
  Transactions,
} from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import { getDeviceSize } from "../../exports/InteractiveUtils";

const DEVICE_SIZE = getDeviceSize();

const menu_array = [
  {
    name: DEVICE_SIZE === "S" ? "Port." : "Portfolios",
    path: "/account/mf/portfolio",
    icon: Portfolio,
    iconSize: 20,
  },
  {
    name: DEVICE_SIZE === "S" ? "SIP" : "SIP",
    path: "/account/mf/sip",
    icon: SIP,
    iconSize: 20,
  },
  {
    name: DEVICE_SIZE === "S" ? "Tran." : "Transactions",
    path: "/account/mf/transaction",
    icon: Transactions,
    iconSize: 20,
  },
  {
    name: DEVICE_SIZE === "S" ? "SIP Trn." : "SIP Transactions",
    path: "/account/mf/siptransaction",
    icon: SIPTransaction,
    iconSize: 20,
  },
  {
    name: DEVICE_SIZE === "S" ? "Acc." : "Accounts",
    path: "/account/mf/clientaccount",
    icon: ProfileUser,
    iconSize: 20,
  },
  {
    name: DEVICE_SIZE === "S" ? "Watch." : "Watchlists",
    path: "/account/mf/watchlist",
    icon: BookMark  ,
    iconSize: 20,
  },
  // {
  //   name: "Filter MF",
  //   path: "/account/mf/filter",
  // },
];

function MFMenu() {
  const location = useLocation();
  const { pathname = "" } = location;
  const ref = useRef();

  const [menu, setMenu] = useState("Portfolio");
  const [menuPopup, setMenuPopup] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setMenuPopup(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const menu_item = menu_array.find((m) => m.path === pathname);
    if (menu_item) {
      setMenu(menu_item.name);
    }
  }, []);

  function NavLinkCallback(menu_item) {
    setMenu(menu_item);
    setMenuPopup(false);
  }

  return (
    <>
      {/* <div
        className="swift-submenu-item"
        onClick={() => {
          setMenuPopup(!menuPopup);
        }}
      >
        <p>{menu}</p>
        {menuPopup ? (
          <>
            <ArrowUp2 size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
          </>
        ) : (
          <>
            <ArrowDown2 size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
          </>
        )}
      </div> */}
      <div ref={ref} className={"swift-submenu " + (menuPopup ? "active" : "")}>
        {menu_array.map((m, index) => {
          return (
            <NavLink
              key={index}
              to={`${m.path}`}
              onClick={() => {
                NavLinkCallback(m.name);
              }}
            >
              <p className={pathname === m.path ? "active" : ""}>
                {DEVICE_SIZE === "S" && (
                  <m.icon
                    color={
                      pathname === m.path
                        ? COLOR_VARS["SWIFT_COLOR1"]
                        : COLOR_VARS["SWIFT_COLOR4"]
                    }
                    size={25}
                  />
                )}
                {m.name}
              </p>
            </NavLink>
          );
        })}
      </div>
    </>
  );
}

function MFManagement() {
  return (
    <div className="swift-mf-management swift-content">
      <div className="swift-submenu-wrapper">
        <MFMenu />
      </div>

      <div className="strategy-content">
        <MFRoutes />
      </div>
    </div>
  );
}

export default MFManagement;
